import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule, NgbOffcanvasModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaginationComponent } from './pagination/pagination.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { ColorTableComponent } from './color-table/color-table.component';
import { AddressDetailComponent } from './address-detail/address-detail.component';
import { CategorySelectComponent } from './category-select/category-select.component';
import { ValuelistSelectorComponent } from './valuelist-selector/valuelist-selector.component';
import { ContactDetailComponent } from './contact-detail/contact-detail.component';
import { CompanyDetailCardComponent } from './company-detail-card/company-detail-card.component';
import { CompanyCardDetailViewComponent } from '../AdvERP/companies/company-card-detail-view/company-card-detail-view.component';
import { QuillEditorComponent } from './quill-editor/quill-editor.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormErrorsComponent } from './form-errors/form-errors.component';
import { CalendarComponent } from './calender/calendar.component';
import { FollowMouseDirective } from './calender/test.directive';
import { ClampDateYearDirective } from './directives/clamp-date-year.directive';
import { ResizableColumnsDirective } from './directives/resizable-columns.directive';
import { CompanyBranchSoftwareSelectComponent } from './company-branch-software-select/company-branch-software-select.component';
import { WorkInProgressComponent } from './work-in-progress/work-in-progress.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CategorySelectorComponent } from './category-selector/category-selector.component';
import { SubCategorySelectorComponent } from './sub-category-selector/sub-category-selector.component';
import { RichTextEditorComponent } from './rich-text-editor/rich-text-editor.component';
import { RichTextEditorModule } from '@advinsoftwares/ngx-rich-text-editor';
import { UicFormComponent } from './uic-form/uic-form.component';
import { NgChartsModule } from 'ng2-charts';
import { UicColorTableComponent } from './uic-color-table/uic-color-table.component';
import { InstructionsComponent } from './instructions/instructions.component';
import { UicTaxComponent } from './uic-tax/uic-tax.component';
import { UicDiscountComponent } from './uic-discount/uic-discount.component';
import { DocumentUploadMasterComponent } from './document-upload-master/document-upload-master.component';
import { OffCanvasComponent } from './off-canvas/off-canvas.component';
import { SimpleDocumentUploadComponent } from './simple-document-upload/simple-document-upload.component';
import { PageNoAccessComponent } from './page-no-access/page-no-access.component';
import { ImportCrossInvoicesButtonComponent } from './import-cross-invoices-button/import-cross-invoices-button.component';
import { AddViaSalesInvoiceButtonComponent } from './import-cross-invoices-button/add-via-sales-invoice-button/add-via-sales-invoice-button.component';
import { AddViaSalesReleaseReferenceButtonComponent } from './import-cross-invoices-button/add-via-sales-release-reference-button/add-via-sales-release-reference-button.component';
import { AddViaPurchaseInvoiceButtonComponent } from './import-cross-invoices-button/add-via-purchase-invoice-button/add-via-purchase-invoice-button.component';
import { AddViaPurchaseReleaseReferenceButtonComponent } from './import-cross-invoices-button/add-via-purchase-release-reference-button/add-via-purchase-release-reference-button.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { SafeUrlPipe } from './Custom-pipe/safe-url.pipe';
import { SafeHtmlPipe } from './Custom-pipe/safe-html.pipe';
import { AddViaIndentButtonComponent } from './import-cross-invoices-button/add-via-indent-button/add-via-indent-button.component';
import { AddViaPurchaseOrderButtonComponent } from './import-cross-invoices-button/add-via-purchase-order-button/add-via-purchase-order-button.component';
import { UicAddressDetailViewComponent } from './uic-address-detail-view/uic-address-detail-view.component';
import { UicBillingDeliveryAddressComponent } from './uic-billing-delivery-address/uic-billing-delivery-address.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { CompanyEmailTemplatesComponent } from '../AdvERP/companies/company-email-templates/company-email-templates.component';
import { CompanyUserLicensesComponent } from '../AdvERP/companies/company-user-licenses/company-user-licenses.component';
import { AddViaIndentButton2Component } from './import-cross-invoices-button/add-via-indent-button-2/add-via-indent-button-2.component';
import { ExportDataButtonComponent } from './export-data-button/export-data-button.component';
import { GenericDetailImportButtonComponent } from './generic-detail-import-button/generic-detail-import-button.component';
import { PolicyTimeRangeTableComponent } from './policy-time-range-table/policy-time-range-table.component';
import { PolicyYesNoToggleComponent } from './policy-yes-no-toggle/policy-yes-no-toggle.component';
import { ExportExcelButtonComponent } from './export-excel-button/export-excel-button.component';
import { NotificationBellComponent } from './notification-bell/notification-bell.component';
import { NotificationToastComponent } from './notification-toast/notification-toast.component';
import { GlobalPolicyRulesComponent } from '../AdvERP/companies/global-policy-rules/global-policy-rules.component';

import { ItemDetailDataComponent } from './item-detail-data/item-detail-data.component';
import { CloneButtonComponent } from './clone-button/clone-button.component';
import { InfoHelpComponent } from './info-help/info-help.component';
import { MultiEmailInputComponent } from './multi-email-input/multi-email-input.component';
import { DocumentEmailPreviewComponent } from './document-email-preview/document-email-preview.component';
@NgModule({
  declarations: [
    InfoHelpComponent,
    LoaderComponent,
    PaginationComponent,
    PageHeaderComponent,
    ColorTableComponent,
    AddressDetailComponent,
    CategorySelectComponent,
    ValuelistSelectorComponent,
    ContactDetailComponent,
    CompanyDetailCardComponent,
    CompanyCardDetailViewComponent,
    QuillEditorComponent,
    FormErrorsComponent,
    CalendarComponent,
    FollowMouseDirective,
    ClampDateYearDirective,
    ResizableColumnsDirective,
    CompanyBranchSoftwareSelectComponent,
    WorkInProgressComponent,
    PageNotFoundComponent,
    CategorySelectorComponent,
    SubCategorySelectorComponent,
    RichTextEditorComponent,
    UicFormComponent,
    UicColorTableComponent,
    InstructionsComponent,
    UicTaxComponent,
    UicDiscountComponent,
    DocumentUploadMasterComponent,
    OffCanvasComponent,
    SimpleDocumentUploadComponent,
    PageNoAccessComponent,
    ImportCrossInvoicesButtonComponent,
    AddViaSalesInvoiceButtonComponent,
    AddViaSalesReleaseReferenceButtonComponent,
    AddViaPurchaseInvoiceButtonComponent,
    AddViaPurchaseReleaseReferenceButtonComponent,
    SafeUrlPipe,
    SafeHtmlPipe,
    AddViaIndentButtonComponent,
    AddViaPurchaseOrderButtonComponent,
    UicAddressDetailViewComponent,
    UicBillingDeliveryAddressComponent,
    BackButtonComponent,
    CompanyEmailTemplatesComponent,
    CompanyUserLicensesComponent,
    AddViaIndentButton2Component,
    ExportDataButtonComponent,
    GenericDetailImportButtonComponent,
    PolicyTimeRangeTableComponent,
    PolicyYesNoToggleComponent,
    ExportExcelButtonComponent,
    NotificationBellComponent,
    NotificationToastComponent,
    GlobalPolicyRulesComponent,
    ItemDetailDataComponent,
    CloneButtonComponent,
    MultiEmailInputComponent,
    DocumentEmailPreviewComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    NgbOffcanvasModule,
    NgSelectModule,
    NgxSkeletonLoaderModule,
    NgChartsModule,
    RichTextEditorModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgbOffcanvasModule,
    HttpClientModule,
    NgbModule,
    InfoHelpComponent,
    LoaderComponent,
    NgSelectModule,
    PaginationComponent,
    PageHeaderComponent,
    ColorTableComponent,
    AddressDetailComponent,
    CategorySelectComponent,
    ValuelistSelectorComponent,
    ContactDetailComponent,
    CompanyDetailCardComponent,
    CompanyCardDetailViewComponent,
    QuillEditorComponent,
    NgxSkeletonLoaderModule,
    FormErrorsComponent,
    FollowMouseDirective,
    ClampDateYearDirective,
    ResizableColumnsDirective,
    CalendarComponent,
    CompanyBranchSoftwareSelectComponent,
    WorkInProgressComponent,
    PageNotFoundComponent,
    CategorySelectorComponent,
    SubCategorySelectorComponent,
    RichTextEditorComponent,
    UicFormComponent,
    NgChartsModule,
    UicColorTableComponent,
    InstructionsComponent,
    UicDiscountComponent,
    UicTaxComponent,
    DocumentUploadMasterComponent,
    OffCanvasComponent,
    SimpleDocumentUploadComponent,
    ImportCrossInvoicesButtonComponent,
    AddViaSalesInvoiceButtonComponent,
    AddViaSalesReleaseReferenceButtonComponent,
    AddViaPurchaseInvoiceButtonComponent,
    AddViaPurchaseReleaseReferenceButtonComponent,
    SafeUrlPipe,
    AddViaIndentButtonComponent,
    AddViaPurchaseOrderButtonComponent,
    UicAddressDetailViewComponent,
    UicBillingDeliveryAddressComponent,
    BackButtonComponent,
    CompanyEmailTemplatesComponent,
    CompanyUserLicensesComponent,
    ExportDataButtonComponent,
    GenericDetailImportButtonComponent,
    PolicyTimeRangeTableComponent,
    PolicyYesNoToggleComponent,
    ExportExcelButtonComponent,
    NotificationBellComponent,
    NotificationToastComponent,
    GlobalPolicyRulesComponent,
    ItemDetailDataComponent,
    CloneButtonComponent,
    MultiEmailInputComponent,
    DocumentEmailPreviewComponent,
  ]
})
export class SharedModule { }
